import { render, staticRenderFns } from "./Cryolab.vue?vue&type=template&id=1090dde5"
import script from "./Cryolab.vue?vue&type=script&lang=js"
export * from "./Cryolab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports